import React, { useEffect } from 'react';

const AuthCallback = () => {
  useEffect(() => {
    // URL에서 토큰 추출
    const params = new URLSearchParams(window.location.hash.substring(1));
    const idToken = params.get('id_token');
    const error = params.get('error');

    if (error) {
      // 에러 발생 시 부모 창에 에러 메시지 전송
      window.opener.postMessage({
        type: 'GOOGLE_AUTH_ERROR',
        error: error
      }, window.location.origin);
    } else if (idToken) {
      // 성공 시 부모 창에 토큰 전송
      window.opener.postMessage({
        type: 'GOOGLE_AUTH_SUCCESS',
        token: idToken
      }, window.location.origin);
    } else {
      // 토큰이 없는 경우
      window.opener.postMessage({
        type: 'GOOGLE_AUTH_ERROR',
        error: '토큰을 받을 수 없습니다.'
      }, window.location.origin);
    }

    // 팝업 창 닫기
    window.close();
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #4285F4',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }}></div>
        <p>로그인 처리 중...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default AuthCallback;
